import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type ConfigSlice = {
    fullConfig: any,
    fullConfigIsLoading: boolean
}

const initialState: ConfigSlice = {
    fullConfig: null,
    fullConfigIsLoading: false
}

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setFullConfig(state, action: PayloadAction<string>) {
            state.fullConfig = action.payload
        },
        setFullConfigIsLoading(state, action: PayloadAction<boolean>) {
            state.fullConfigIsLoading = action.payload
        }
    }
})

export const { setFullConfig, setFullConfigIsLoading } = configSlice.actions
export const configReducer = configSlice.reducer;
